// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Common = require("../utils/Common.bs.js");
var Js_math = require("rescript/lib/js/js_math.js");
var MM_parser = require("../mm-utils/MM_parser.bs.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MM_wrk_client = require("../worker/MM_wrk_client.bs.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var MM_substitution = require("../mm-utils/MM_substitution.bs.js");
var Expln_React_Modal = require("../../rescript-utils/main/react-components/Expln_React_Modal.bs.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.bs.js");
var JsxPPXReactSupport = require("rescript/lib/js/jsxPPXReactSupport.js");
var MM_wrk_search_asrt = require("../worker/MM_wrk_search_asrt.bs.js");
var Paper = require("@mui/material/Paper").default;
var Expln_utils_promise = require("../../rescript-utils/main/Expln_utils_promise.bs.js");
var Button = require("@mui/material/Button").default;
var Select = require("@mui/material/Select").default;
var Divider = require("@mui/material/Divider").default;
var Checkbox = require("@mui/material/Checkbox").default;
var MenuItem = require("@mui/material/MenuItem").default;
var TextField = require("@mui/material/TextField").default;
var InputLabel = require("@mui/material/InputLabel").default;
var Pagination = require("@mui/material/Pagination").default;
var FormControl = require("@mui/material/FormControl").default;

function makeInitialState(frms, initialTyp) {
  if (MM_substitution.frmsSize(frms) === 0) {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "Cannot search assertions when frms are empty."
          },
          Error: new Error()
        };
  }
  var allTypes = MM_substitution.frmsGetAllTypes(frms);
  return {
          label: "",
          allTypes: allTypes,
          typ: Belt_Option.getWithDefault(Belt_Option.map(initialTyp, (function (iniTyp) {
                      if (allTypes.includes(iniTyp)) {
                        return iniTyp;
                      } else {
                        return Caml_array.get(allTypes, 0);
                      }
                    })), Caml_array.get(allTypes, 0)),
          patternStr: "",
          patternErr: undefined,
          results: undefined,
          resultsForRender: undefined,
          resultsPerPage: 10,
          resultsMaxPage: 1,
          resultsPage: 1,
          checkedResultsIdx: []
        };
}

function setResults(st, results, getFrmLabelBkgColor) {
  var maxPage = Js_math.ceil_int(results.length / st.resultsPerPage);
  return {
          label: st.label,
          allTypes: st.allTypes,
          typ: st.typ,
          patternStr: st.patternStr,
          patternErr: st.patternErr,
          results: results,
          resultsForRender: results.map(function (result) {
                var numOfStmt = result.stmts.length;
                var lastStmtIdx = numOfStmt - 1 | 0;
                return React.createElement(Paper, {
                            style: {
                              padding: "3px"
                            },
                            children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                                      children: Caml_option.some(null)
                                    }, result.newDisjStr.map(function (disjStr, i) {
                                          return JsxPPXReactSupport.createElementVariadicWithKey("disj-" + String(i), React.Fragment, {
                                                      children: null
                                                    }, [
                                                      "$d " + disjStr + " $.",
                                                      React.createElement(Divider, {})
                                                    ]);
                                        }), result.stmts.map(function (stmt, i) {
                                          var tmp = {
                                            borderRadius: "3px"
                                          };
                                          var tmp$1 = i === lastStmtIdx ? Curry._1(getFrmLabelBkgColor, stmt.label) : undefined;
                                          if (tmp$1 !== undefined) {
                                            tmp.backgroundColor = tmp$1;
                                          }
                                          return JsxPPXReactSupport.createElementVariadicWithKey("stmt-" + String(i), React.Fragment, {
                                                      children: null
                                                    }, [
                                                      React.createElement("span", {
                                                            style: tmp
                                                          }, stmt.label),
                                                      React.createElement("span", undefined, ": " + stmt.exprStr),
                                                      i !== lastStmtIdx ? React.createElement(Divider, {}) : null
                                                    ]);
                                        })))
                          });
              }),
          resultsPerPage: st.resultsPerPage,
          resultsMaxPage: maxPage,
          resultsPage: 1,
          checkedResultsIdx: []
        };
}

function setPage(st, page) {
  return {
          label: st.label,
          allTypes: st.allTypes,
          typ: st.typ,
          patternStr: st.patternStr,
          patternErr: st.patternErr,
          results: st.results,
          resultsForRender: st.resultsForRender,
          resultsPerPage: st.resultsPerPage,
          resultsMaxPage: st.resultsMaxPage,
          resultsPage: Math.max(0, Math.min(st.resultsMaxPage, page)),
          checkedResultsIdx: st.checkedResultsIdx
        };
}

function setLabel(st, label) {
  return {
          label: label,
          allTypes: st.allTypes,
          typ: st.typ,
          patternStr: st.patternStr,
          patternErr: st.patternErr,
          results: st.results,
          resultsForRender: st.resultsForRender,
          resultsPerPage: st.resultsPerPage,
          resultsMaxPage: st.resultsMaxPage,
          resultsPage: st.resultsPage,
          checkedResultsIdx: st.checkedResultsIdx
        };
}

function setType(st, typ) {
  return {
          label: st.label,
          allTypes: st.allTypes,
          typ: typ,
          patternStr: st.patternStr,
          patternErr: st.patternErr,
          results: st.results,
          resultsForRender: st.resultsForRender,
          resultsPerPage: st.resultsPerPage,
          resultsMaxPage: st.resultsMaxPage,
          resultsPage: st.resultsPage,
          checkedResultsIdx: st.checkedResultsIdx
        };
}

function setPatternStr(st, patternStr) {
  return {
          label: st.label,
          allTypes: st.allTypes,
          typ: st.typ,
          patternStr: patternStr,
          patternErr: st.patternErr,
          results: st.results,
          resultsForRender: st.resultsForRender,
          resultsPerPage: st.resultsPerPage,
          resultsMaxPage: st.resultsMaxPage,
          resultsPage: st.resultsPage,
          checkedResultsIdx: st.checkedResultsIdx
        };
}

function setPatternErr(st, patternErr) {
  return {
          label: st.label,
          allTypes: st.allTypes,
          typ: st.typ,
          patternStr: st.patternStr,
          patternErr: patternErr,
          results: st.results,
          resultsForRender: st.resultsForRender,
          resultsPerPage: st.resultsPerPage,
          resultsMaxPage: st.resultsMaxPage,
          resultsPage: st.resultsPage,
          checkedResultsIdx: st.checkedResultsIdx
        };
}

function toggleResultChecked(st, idx) {
  if (st.checkedResultsIdx.includes(idx)) {
    return {
            label: st.label,
            allTypes: st.allTypes,
            typ: st.typ,
            patternStr: st.patternStr,
            patternErr: st.patternErr,
            results: st.results,
            resultsForRender: st.resultsForRender,
            resultsPerPage: st.resultsPerPage,
            resultsMaxPage: st.resultsMaxPage,
            resultsPage: st.resultsPage,
            checkedResultsIdx: st.checkedResultsIdx.filter(function (i) {
                  return i !== idx;
                })
          };
  } else {
    return {
            label: st.label,
            allTypes: st.allTypes,
            typ: st.typ,
            patternStr: st.patternStr,
            patternErr: st.patternErr,
            results: st.results,
            resultsForRender: st.resultsForRender,
            resultsPerPage: st.resultsPerPage,
            resultsMaxPage: st.resultsMaxPage,
            resultsPage: st.resultsPage,
            checkedResultsIdx: st.checkedResultsIdx.concat([idx])
          };
  }
}

function MM_cmp_search_asrt(props) {
  var onResultsSelected = props.onResultsSelected;
  var onCanceled = props.onCanceled;
  var onTypChange = props.onTypChange;
  var initialTyp = props.initialTyp;
  var frms = props.frms;
  var wrkCtx = props.wrkCtx;
  var disjText = props.disjText;
  var varsText = props.varsText;
  var preCtx = props.preCtx;
  var preCtxVer = props.preCtxVer;
  var settings = props.settings;
  var settingsVer = props.settingsVer;
  var modalRef = props.modalRef;
  var match = React.useState(function () {
        return makeInitialState(frms, initialTyp);
      });
  var setState = match[1];
  var state = match[0];
  var getFrmLabelBkgColor = function (label) {
    var frm = MM_substitution.frmsGetByLabel(frms, label);
    if (frm !== undefined) {
      return MM_react_common.getFrmLabelBkgColor(frm.frame, settings);
    }
    
  };
  var actResultsRetrieved = function (results) {
    Curry._1(setState, (function (__x) {
            return setResults(__x, results, getFrmLabelBkgColor);
          }));
  };
  var makeActTerminate = function (modalId, param) {
    MM_wrk_client.terminateWorker(undefined);
    Expln_React_Modal.closeModal(modalRef, modalId);
  };
  var actSearch = function (param) {
    Curry._1(onTypChange, state.typ);
    var incorrectSymbol = Common.getSpaceSeparatedValuesAsArray(state.patternStr).find(function (sym) {
          return Belt_Option.isNone(MM_context.ctxSymToInt(wrkCtx, sym));
        });
    if (incorrectSymbol !== undefined) {
      Curry._1(setState, (function (__x) {
              return setPatternErr(__x, "'" + incorrectSymbol + "' - is not a constant or a variable.");
            }));
      return actResultsRetrieved([]);
    } else {
      Curry._1(setState, (function (__x) {
              return setPatternErr(__x, undefined);
            }));
      Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                  return MM_react_common.rndProgress("Searching", 0, undefined, undefined);
                })), (function (modalId) {
              Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                      return MM_react_common.rndProgress("Searching", 0, (function (param) {
                                    return makeActTerminate(modalId, param);
                                  }), undefined);
                    }));
              return Expln_utils_promise.promiseMap(MM_wrk_search_asrt.searchAssertions(settingsVer, settings, preCtxVer, preCtx, varsText, disjText, state.label.trim(), state.typ, MM_context.ctxStrToIntsExn(wrkCtx, state.patternStr), (function (pct) {
                                Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                        return MM_react_common.rndProgress("Searching", pct, (function (param) {
                                                      return makeActTerminate(modalId, param);
                                                    }), undefined);
                                      }));
                              })), (function (found) {
                            Expln_React_Modal.closeModal(modalRef, modalId);
                            actResultsRetrieved(found);
                          }));
            }));
      return ;
    }
  };
  var actLabelChange = function (str) {
    Curry._1(setState, (function (__x) {
            return setLabel(__x, str);
          }));
  };
  var actTypeChange = function (newTypeStr) {
    Curry._1(setState, (function (__x) {
            return setType(__x, MM_context.ctxSymToIntExn(wrkCtx, newTypeStr));
          }));
  };
  var actPatternChange = function (newPatternStr) {
    Curry._1(setState, (function (__x) {
            return setPatternStr(__x, newPatternStr);
          }));
  };
  var rndError = function (msgOpt) {
    if (msgOpt !== undefined) {
      return React.createElement("pre", {
                  style: {
                    color: "red"
                  }
                }, msgOpt);
    } else {
      return null;
    }
  };
  var rndPattern = function (param) {
    var partial_arg = MM_react_common.kbrdClbkMake(MM_react_common.keyEsc, undefined, undefined, undefined, onCanceled, undefined);
    var partial_arg$1 = MM_react_common.kbrdClbkMake(MM_react_common.keyEnter, undefined, undefined, undefined, actSearch, undefined);
    return React.createElement(TextField, {
                value: state.patternStr,
                label: "Pattern",
                size: "small",
                style: {
                  width: "300px"
                },
                onChange: (function (param) {
                    return Expln_React_common.evt2str(actPatternChange, param);
                  }),
                onKeyDown: (function (param) {
                    return MM_react_common.kbrdHnd2(partial_arg$1, partial_arg, param);
                  }),
                autoFocus: true
              });
  };
  var rndLabel = function (param) {
    var partial_arg = MM_react_common.kbrdClbkMake(MM_react_common.keyEsc, undefined, undefined, undefined, onCanceled, undefined);
    var partial_arg$1 = MM_react_common.kbrdClbkMake(MM_react_common.keyEnter, undefined, undefined, undefined, actSearch, undefined);
    return React.createElement(TextField, {
                value: state.label,
                label: "Label",
                size: "small",
                style: {
                  width: "100px"
                },
                onChange: (function (param) {
                    return Expln_React_common.evt2str(actLabelChange, param);
                  }),
                onKeyDown: (function (param) {
                    return MM_react_common.kbrdHnd2(partial_arg$1, partial_arg, param);
                  })
              });
  };
  var rndTyp = function (param) {
    return React.createElement(FormControl, {
                size: "small",
                children: Caml_option.some(null)
              }, React.createElement(InputLabel, {
                    id: "asrt-type-select-label",
                    children: "Type"
                  }), React.createElement(Select, {
                    labelId: "asrt-type-select-label",
                    label: "Type",
                    value: MM_context.ctxIntToSymExn(wrkCtx, state.typ),
                    onChange: (function (param) {
                        return Expln_React_common.evt2str(actTypeChange, param);
                      }),
                    children: Caml_option.some(state.allTypes.map(function (typI) {
                              var typStr = MM_context.ctxIntToSymExn(wrkCtx, typI);
                              return JsxPPXReactSupport.createElementWithKey(typStr, MenuItem, {
                                          value: typStr,
                                          children: Caml_option.some(typStr)
                                        });
                            }))
                  }));
  };
  var rndFilters = function (param) {
    return React.createElement(Expln_React_Column.make, {
                children: Caml_option.some(null)
              }, React.createElement(Expln_React_Row.make, {
                    children: Caml_option.some(null)
                  }, rndLabel(undefined), rndTyp(undefined), rndPattern(undefined), React.createElement(Button, {
                        onClick: (function (param) {
                            actSearch(undefined);
                          }),
                        variant: "contained",
                        color: "grey",
                        children: "Search"
                      }), React.createElement(Button, {
                        onClick: (function (param) {
                            Curry._1(onCanceled, undefined);
                          }),
                        children: "Cancel"
                      })), rndError(state.patternErr));
  };
  var rndPagination = function (totalNumOfResults) {
    if (state.resultsPerPage < totalNumOfResults) {
      return React.createElement(Pagination, {
                  count: state.resultsMaxPage,
                  page: state.resultsPage,
                  onChange: (function (param, newPage) {
                      Curry._1(setState, (function (__x) {
                              return setPage(__x, newPage);
                            }));
                    })
                });
    } else {
      return null;
    }
  };
  var rndResultButtons = function (param) {
    return React.createElement(Expln_React_Row.make, {
                children: Caml_option.some(null)
              }, React.createElement(Button, {
                    onClick: (function (param) {
                        var results = state.results;
                        if (results !== undefined) {
                          return Curry._1(onResultsSelected, results.filter(function (param, i) {
                                          return state.checkedResultsIdx.includes(i);
                                        }));
                        }
                        
                      }),
                    variant: "contained",
                    disabled: state.checkedResultsIdx.length === 0,
                    children: "Choose selected"
                  }), React.createElement(Button, {
                    onClick: (function (param) {
                        Curry._1(onCanceled, undefined);
                      }),
                    children: "Cancel"
                  }));
  };
  var rndResults = function (param) {
    var resultsForRender = state.resultsForRender;
    if (resultsForRender === undefined) {
      return null;
    }
    var items = [];
    var minI = Math.imul(state.resultsPage - 1 | 0, state.resultsPerPage);
    var maxI = Math.min((minI + state.resultsPerPage | 0) - 1 | 0, resultsForRender.length - 1 | 0);
    for(var i = minI; i <= maxI; ++i){
      var resultForRender = Caml_array.get(resultsForRender, i);
      items.push(resultForRender);
    }
    var totalNumOfResults = resultsForRender.length;
    return React.createElement(Expln_React_Column.make, {
                children: Caml_option.some(null)
              }, rndResultButtons(undefined), rndPagination(totalNumOfResults), items.map(function (item, i) {
                    var resIdx = minI + i | 0;
                    return React.createElement("table", {
                                key: String(resIdx)
                              }, React.createElement("tbody", undefined, React.createElement("tr", undefined, React.createElement("td", undefined, React.createElement(Checkbox, {
                                                checked: state.checkedResultsIdx.includes(resIdx),
                                                onChange: (function (param) {
                                                    Curry._1(setState, (function (__x) {
                                                            return toggleResultChecked(__x, resIdx);
                                                          }));
                                                  })
                                              })), React.createElement("td", undefined, item))));
                  }), rndPagination(totalNumOfResults), rndResultButtons(undefined));
  };
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                        spacing: 1,
                        children: Caml_option.some(null)
                      }, rndFilters(undefined), rndResults(undefined)))
            });
}

var make = MM_cmp_search_asrt;

exports.makeInitialState = makeInitialState;
exports.setResults = setResults;
exports.setPage = setPage;
exports.setLabel = setLabel;
exports.setType = setType;
exports.setPatternStr = setPatternStr;
exports.setPatternErr = setPatternErr;
exports.toggleResultChecked = toggleResultChecked;
exports.make = make;
/* react Not a pure module */
